export const CATEGORIES = [
  { value: "restaurants", label: "Restaurants" },
  { value: "bars", label: "Bars" },
  { value: "hotels", label: "Hotels" },
  { value: "retail", label: "Retail" },
  { value: "cafes", label: "Cafes" },
  { value: "salons", label: "Salons" },
  { value: "other", label: "Other" },
];

export const PLATFORMS = [
  { value: "tiktok", label: "TikTok" },
  { value: "instagram", label: "Instagram" },
  { value: "facebook", label: "Facebook" },
  { value: "yelp", label: "Yelp" },
  { value: "linkedin", label: "LinkedIn" },
  { value: "web", label: "Web" },
];

export const US_STATES = {
  AL: "Alabama", AK: "Alaska", AZ: "Arizona", AR: "Arkansas", CA: "California", CO: "Colorado",
  CT: "Connecticut", DE: "Delaware", DC: "District of Columbia", FL: "Florida", GA: "Georgia",
  HI: "Hawaii", ID: "Idaho", IL: "Illinois", IN: "Indiana", IA: "Iowa", KS: "Kansas", KY: "Kentucky",
  LA: "Louisiana", ME: "Maine", MD: "Maryland", MA: "Massachusetts", MI: "Michigan", MN: "Minnesota",
  MS: "Mississippi", MO: "Missouri", MT: "Montana", NE: "Nebraska", NV: "Nevada", NH: "New Hampshire",
  NJ: "New Jersey", NM: "New Mexico", NY: "New York", NC: "North Carolina", ND: "North Dakota",
  OH: "Ohio", OK: "Oklahoma", OR: "Oregon", PA: "Pennsylvania", RI: "Rhode Island",
  SC: "South Carolina", SD: "South Dakota", TN: "Tennessee", TX: "Texas", UT: "Utah", VT: "Vermont",
  VA: "Virginia", WA: "Washington", WV: "West Virginia", WI: "Wisconsin", WY: "Wyoming",
};

export const POS_SYSTEMS = ["Square", "Toast", "Clover", "Lightspeed", "Shopify POS", "Revel", "NCR Aloha",
  "Oracle Micros", "Focus POS", "Helcim", "KORONA POS", "Global Payments", "SpotOn", "Heartland", "TouchBistro", "Lavu", "Upserve", "Opera", "Shift4"];

export const ARCHIVE_REASONS = [
  { value: "not_a_fit", label: "Not a fit" }, { value: "too_small", label: "Too small" },
  { value: "already_switched", label: "Already switched POS" }, { value: "other", label: "Other" },
];
export const AUTO_REASONS = [{ value: "toast_shift4", label: "On Toast / Shift4" }];
const OLD_REASONS = [{ value: "dead_deal", label: "Dead deal" }, { value: "closed", label: "Closed" }, { value: "duplicate", label: "Duplicate" }, { value: "cant_reach", label: "Can't reach" }];
export const archiveLabel = (v) => [...ARCHIVE_REASONS, ...AUTO_REASONS, ...OLD_REASONS].find((r) => r.value === v)?.label;

export const OUTCOMES = [
  { value: "interested", label: "Interested", on: "bg-emerald-600 border-emerald-600 text-white", badge: "bg-emerald-50 text-emerald-700" },
  { value: "booked_demo", label: "Booked demo", on: "bg-blue-700 border-blue-700 text-white", badge: "bg-blue-700 text-white" },
  { value: "not_now", label: "Not now", on: "bg-amber-500 border-amber-500 text-white", badge: "bg-amber-50 text-amber-700" },
  { value: "not_interested", label: "Not interested", on: "bg-slate-600 border-slate-600 text-white", badge: "bg-slate-100 text-slate-600" },
];
export const outcomeOf = (v) => OUTCOMES.find((o) => o.value === v);

export const postedLabel = (iso, approx = false) => {
  if (!iso) return "Post date unknown";
  const d = new Date(`${iso}T12:00:00`);
  return approx ? `Posted ~${d.toLocaleDateString("en-US", { month: "short", year: "numeric" })}` : `Posted ${d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}`;
};

export const FRESH_DAYS = 7;
export const isFresh = (iso) => {
  if (!iso) return false;
  const cutoff = new Date();
  cutoff.setDate(cutoff.getDate() - FRESH_DAYS);
  return iso >= cutoff.toLocaleDateString("en-CA");
};

export const HOT_DAYS = 15;
export const hotDaysLeft = (lead) => {
  if (lead.intent !== "hot") return null;
  const base = lead.signal_date || (lead.found_at || "").slice(0, 10);
  if (!base) return null;
  const age = Math.round((new Date(`${localToday()}T12:00:00`) - new Date(`${base}T12:00:00`)) / 86400000);
  const left = HOT_DAYS - Math.max(age, 0);
  return left >= 0 ? left : null;
};

export const localToday = () => new Date().toLocaleDateString("en-CA");

export const catLabel = (v) => CATEGORIES.find((c) => c.value === v)?.label || v;
export const platLabel = (v) => PLATFORMS.find((p) => p.value === v)?.label || v;
